module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hospental-cb835cedb3584f08bd4326d98776160f.svg";